import { memo } from 'react';
import { UserAvatar } from '@shared/components/ui/UserAvatar';
import { UserModel } from '../../models/User';
import { DropdownActions } from '../interaction/DropdownActions';

interface UserListRowProps {
  user: UserModel;
  roleName: string;
  displayName: string;
  isLast: boolean;
  showActions: boolean;
  onRefetch: () => void;
}

export const UserListRow = memo(function UserListRow({
  user,
  roleName,
  displayName,
  isLast,
  showActions,
  onRefetch,
}: UserListRowProps) {
  return (
    <div
      className={`grid grid-cols-[1fr_auto_2.5rem] items-center gap-3 px-4 py-3.5 sm:py-4 ${
        isLast ? '' : 'border-b border-border'
      }`}
      data-testid={`user-row-${user.id}`}
    >
      <div className="flex min-w-0 items-center gap-3">
        <UserAvatar
          name={displayName}
          image={user.profile_photo_path ?? undefined}
          size="sm"
          className="shrink-0"
          data-testid={`user-avatar-${user.id}`}
        />
        <div className="min-w-0 pr-1">
          <p className="truncate text-sm font-medium text-foreground">{displayName}</p>
          {user.email ? <p className="mt-0.5 truncate text-sm text-muted-foreground">{user.email}</p> : null}
        </div>
      </div>

      <span className="max-w-[9rem] truncate rounded-full border border-border bg-muted/40 px-2.5 py-1 text-xs font-medium text-foreground sm:max-w-[11rem]">
        {roleName}
      </span>

      <div className="flex justify-end">
        {showActions ? (
          <DropdownActions user={user} onDelete={onRefetch} onChangeRole={onRefetch} refetch={onRefetch} />
        ) : null}
      </div>
    </div>
  );
});
